import rfianswerSerializer from "./rfiAnswer";
const referenceFromServerMap = reference => ({
  createdAt: reference.created_at,
  createdBy: reference.created_by,
  type: reference.reference_type,
  uid: reference.reference_uid,
});
export default {
  fromServer: data => ({
    answerDueDate: data.answer_due_date,
    answeredAt: data.answered_at,
    answeredDirectlyAt: data.answered_directly_at,
    answeredDirectlyBy: data.answered_directly_by,
    createdAt: data.created_at,
    createdBy: data.created_by,
    directions: data.directions,
    distributedAt: data.distributed_at,
    distributedBy: data.distributed_by,
    submitter: data.submitter,
    managerApprovalDueDate: data.manager_approval_due_date,
    managers: data.managers || [],
    number: data.number,
    publicationDueDate: data.publication_due_date,
    question: data.question,
    references: (data.references || []).map(referenceFromServerMap),
    returnedAt: data.returned_at,
    reviewers: data.reviewers || [],
    revision: data.revision,
    sentForReviewAt: data.sent_for_review_at,
    sentForReviewBy: data.sent_for_review_by,
    status: data.status,
    subNumber: data.sub_number,
    submittedAt: data.submitted_at,
    title: data.title,
    uid: data.uid,
    updatedAt: data.updated_at,
    updatedBy: data.updated_by,
    userCreatedAt: data.user_created_at,
    voidedAt: data.voided_at,
    voidedBy: data.voided_by,
    watchers: data.watchers || [],
    isReturned: data.is_returned,
  }),
  toServer: data => ({
    answer: data.answer && rfianswerSerializer.toServer(data.answer),
    answer_due_date: data.answerDueDate,
    directions: data.directions,
    distributed_to: data.distributedTo,
    submitter: data.submitter,
    manager_approval_due_date: data.managerApprovalDueDate,
    managers:
      data.managers &&
      data.managers.map(({ type = "user", user_id }) => ({
        type,
        uid: user_id,
      })),
    number: data.number,
    publication_due_date: data.publicationDueDate,
    question: data.question,
    references_added: data.referencesAdded,
    references_removed: data.referencesRemoved,
    reviewers:
      data.reviewers &&
      data.reviewers.map(({ type = "user", user_id }) => ({
        type,
        uid: user_id,
      })),
    revision: data.revision,
    status_uid: data.statusUid,
    sub_number: data.subNumber,
    title: data.title,
    user_created_at: data.userCreatedAt,
    watchers: data.watchers,
  }),
};
